module.exports = __webpack_public_path__ + "src/assets/fonts/glyphicons-halflings-regular.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/glyphicons-halflings-regular.svg
// module id = 35
// module chunks = 0